export default __webpack_public_path__ + "static/media/Sage's Belt of the Purple Sun.61fab326.jpg";